export default __webpack_public_path__ + "static/media/thumbnail.cfd05ab6.webp";